export const isPublicCertificate = () => window.location.pathname.includes('/learn/certificate/')
